// 현재 시점 상태 벡터
import { RoastingSeries, RoastLog } from "../input/roastingSeriesTypes";

export interface CurrentState {
  tDev: number; // sec
  BT: number;
  ROR: number;
}
/**
 * 최근 로그를 기반으로 현재 로스팅 상태를 계산
 * (tDev, BT, 단기 ROR)
 */
export function buildCurrentState(logs: RoastLog[], devStartIdx: number): CurrentState {
  const curr = logs.at(-1)!;
  const prev = logs.at(-6)!; // 5초 전

  return {
    tDev: curr.time - logs[devStartIdx].time,
    BT: curr.BT,
    ROR: (curr.BT - prev.BT) / 5,
  };
}

export function buildCurrentStateFromSeries(series: RoastingSeries): CurrentState {
  const { series: points, dryEndTime } = series;

  if (dryEndTime == null || points.length < 2) {
    throw new Error("Invalid series for CurrentState");
  }

  const last = points[points.length - 1];
  const prev = points[points.length - 2];

  const dt = last.time - prev.time;
  const ror = dt > 0 ? (last.bt - prev.bt) / dt : 0;

  return {
    tDev: last.time - dryEndTime,
    BT: last.bt,
    ROR: ror,
  };
}
